import { ReactNode } from 'react';

import { MainPartEditTouched } from './MainPartEdit.props';
import { PartObject } from '../../../@types/part.type';

export const sectionGridSx = {
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
  gap: '12px 20px',
};

interface FieldErrors {
  serial1?: string;
}

export const fieldErrors = (
  value: PartObject,
  touched: MainPartEditTouched,
  validate: boolean
): FieldErrors => {
  const out: FieldErrors = {};
  if ((touched.serial1 || validate) && !value.serial1?.trim()) {
    out.serial1 = 'Serial 1 is required';
  }
  return out;
};

export const conditionHistoryHelper = (value: PartObject): ReactNode | undefined => {
  const history = value.partConditionHistory;
  if (!history) return undefined;
  const parts: string[] = [];
  if (history.serviceId) parts.push(`Service ${history.serviceId}`);
  if (history.lastLocation) parts.push(`Last location: ${history.lastLocation}`);
  if (history.lastCondition) parts.push(`Last condition: ${history.lastCondition}`);
  if (parts.length === 0) return undefined;
  return parts.join(' · ');
};
